module.exports = __webpack_public_path__ + "img/19.1.49a92c6e.jpg";